module.exports = __webpack_public_path__ + "img/81eb873fe0a345da82a73635397eb369_mergeImage.5e5b1888.png";